import { JBaseApi } from '../base';
import { OF } from '../../util';
import { jUserList, jUserLittle } from '../../types/user';
import { AddRemoveActionParams, GetActionUsersParams } from '../../types/socialAction';
import { ApiWrapper, FormatList } from '../../types/utils';
import { jLinkLittle } from '../../types/link';

export class JSocialActionApi extends JBaseApi {
    public getUsers<T extends jUserLittle = jUserList>(
        params: GetActionUsersParams,
        format?: FormatList,
    ): Promise<ApiWrapper<T[]>> {
        return this.network.post({
            o: 'customAction',
            f: 'getUsers',
            ...params,
            format: format ?? 'raw-list',
        } as OF);
    }

    public add<T extends jLinkLittle = jLinkLittle>(
        params: AddRemoveActionParams,
        format?: FormatList,
    ): Promise<ApiWrapper<T>> {
        return this.network.post({
            o: 'customAction',
            f: 'add',
            ...params,
            format: format ?? 'raw-little',
        } as OF);
    }

    public remove(params: AddRemoveActionParams, format?: FormatList): Promise<ApiWrapper<boolean>> {
        return this.network.post({
            o: 'customAction',
            f: 'remove',
            ...params,
            format: format ?? 'raw-little',
        } as OF);
    }
}
